module.exports = __webpack_public_path__ + "img/change_vip.a1ad7202.png";